export const AddPaymentMethodIcon = ({
  strokeColor = "var(--color-stroke-active)",
  ...props
}: any) => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none">
    <path
      d="M64.1673 27.4792H5.83398C4.63815 27.4792 3.64648 26.4875 3.64648 25.2917C3.64648 24.0958 4.63815 23.1042 5.83398 23.1042H64.1673C65.3631 23.1042 66.3548 24.0958 66.3548 25.2917C66.3548 26.4875 65.3631 27.4792 64.1673 27.4792Z"
      fill={strokeColor}
    />
    <path
      d="M23.3333 50.8125H17.5C16.3042 50.8125 15.3125 49.8208 15.3125 48.625C15.3125 47.4292 16.3042 46.4375 17.5 46.4375H23.3333C24.5292 46.4375 25.5208 47.4292 25.5208 48.625C25.5208 49.8208 24.5292 50.8125 23.3333 50.8125Z"
      fill={strokeColor}
    />
    <path
      d="M42.2917 50.8125H30.625C29.4292 50.8125 28.4375 49.8208 28.4375 48.625C28.4375 47.4292 29.4292 46.4375 30.625 46.4375H42.2917C43.4875 46.4375 44.4792 47.4292 44.4792 48.625C44.4792 49.8208 43.4875 50.8125 42.2917 50.8125Z"
      fill={strokeColor}
    />
    <path
      d="M51.2173 62.4792H18.784C7.17565 62.4792 3.64648 58.9792 3.64648 47.4875V23.5125C3.64648 12.0208 7.17565 8.52084 18.784 8.52084H51.1881C62.7965 8.52084 66.3257 12.0208 66.3257 23.5125V47.4583C66.3548 58.9792 62.8256 62.4792 51.2173 62.4792ZM18.784 12.8958C9.62565 12.8958 8.02148 14.4708 8.02148 23.5125V47.4583C8.02148 56.5 9.62565 58.075 18.784 58.075H51.1881C60.3465 58.075 61.9507 56.5 61.9507 47.4583V23.5125C61.9507 14.4708 60.3465 12.8958 51.1881 12.8958H18.784Z"
      fill={strokeColor}
    />
  </svg>
);
